import { defineStore } from "pinia";
import socket from "@/services/socket";
import { useUserPreferencesStore } from "./useUserPreferencesStore";
import type { Player, VoiceTown } from "@/types";

interface VoiceChatState {
  town: VoiceTown | null;
  isMuted: boolean;
}

export const useVoiceChatStore = defineStore("voiceChat", {
  state: (): VoiceChatState => ({
    town: null,
    isMuted: false,
  }),
  actions: {
    setTown(town: VoiceTown | null) {
      this.town = town;
    },
    moveToChannel(channelId: string) {
      const userPreferences = useUserPreferencesStore();
      socket.send("moveVoiceChannel", {playerTag: userPreferences.discordName, channel: channelId });
    },
    joinPlayer(player: Player) {
      this.town?.channels.forEach((channel) => {
        if (channel.members.some((p) => p.tag === player.discordTag)) {
          this.moveToChannel(channel.id);
          return;
        }
      });
    },
    goDowntown() {
      const userPreferences = useUserPreferencesStore();
      socket.send("goDowntown", {playerTag: userPreferences.discordName });
    },
    goToSleep() {
      const userPreferences = useUserPreferencesStore();
      socket.send("goToSleep", {playerTag: userPreferences.discordName });
    },
    sendToSleep() {
      socket.send("sendToSleep");
    },
    gatherTownsquare() {
      socket.send("gatherTownsquare")
    },
    mute(muteState: boolean) {
      this.isMuted = muteState;
      socket.send("mute", { mute: muteState });
    },
    toggleMute() {
      this.mute(!this.isMuted);
    }
  },
});
